import { FunctionComponent, useState } from "react"
import { useAppContext } from "./AppContext";
import { useTranslation } from "react-i18next";
import { LinkButton } from "./LinkButton";
import { cap } from "../lib/cap";
import { useSolidAuth, useResource, useMatchSubject } from "@ldo/solid-react";
import { UserPreferencesShapeType } from "../.ldo/spoty_ldo.shapeTypes";
import { Modal } from "./Modal";
import { changeData, commitData } from "@ldo/solid";
import { useProfile } from "../lib/profile"
import { spoty } from "../lib/ns";
import appInfo from "../app-info.json";
// CSS
import "./Preferences.css"

// This component allows the user to edit their preferences.
export const Preferences: FunctionComponent = () => {
  console.debug("Preferences: rendering")

  const { session } = useSolidAuth();
  const [appCtx, dispatch] = useAppContext();
  const { t } = useTranslation();
  const [preferencesSavedPod, setPreferencesSavedPod] = useState(false);

  const profile = useProfile();
  const preferencesUri = profile?.preferencesFile?.["@id"];
  const preferencesResource = useResource(preferencesUri);

  const preferences = useMatchSubject(
      UserPreferencesShapeType,
      "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
      spoty.UserPreferences,
    );

  function setLanguage(lang: string) {
    dispatch({ type: "setLanguage", value: lang });
  }

  function setLocaleSuffix(localeSuffix: string) {
    dispatch({type: "setLocaleSuffix", value: localeSuffix});
  }

  async function savePreferencesOnPod() {
    if (!preferences || !preferencesResource) return;
    const newPreferences = changeData(preferences[0], preferencesResource);

    newPreferences.value = JSON.stringify(appCtx.preferences);
    
    await commitData(newPreferences);
    setPreferencesSavedPod(true);
    // TODO later: do this when the dialog is closed rather than after a fixed delay
    setTimeout(() => setPreferencesSavedPod(false), 3000)
  }

  return <>
    <h1>{cap(t('preferences'))}</h1>
    <p><label>{cap(t('language'))}:&nbsp;
      <select
        value={appCtx.preferences.language}
        onChange={evt => {
          setLanguage(evt.target.value);
          setPreferencesSavedPod(false);
        }}
      >
        {Object.entries(appInfo.locales).map(([tag, label]) =>
          <option key={tag} value={tag}>{label}</option>
        )}
      </select>
    </label></p>
    
    <p><label>{cap(t('locale'))}:&nbsp;
      <input
        value={appCtx.preferences.localeSuffix}
        onChange={evt => {
          setLocaleSuffix(evt.target.value);
          setPreferencesSavedPod(false);
        }}
      />
    </label></p>
  
    { session.isLoggedIn
    ? <><button id="saveButton" onClick={savePreferencesOnPod}>{t("Save on my pod")}</button>
    {preferencesSavedPod && <p>{t("Your preferences have been saved on your pod")}</p>}
    </>
    : null
    }
  </>
}

// This component display a "gear" link that opens a modal window displaying `Preferences`.
export const PreferencesDialogButton: FunctionComponent = () => {
  const [ showDialog, setShowDialog ] = useState(false);

  // console.debug("PreferencesButtonDialog: rendering");

  const { t } = useTranslation();

  return <>
    <LinkButton onClick={() => setShowDialog(true)} help={cap(t('preferences'))}>⚙</LinkButton>
    <Modal show={showDialog}
      setShow={setShowDialog}
    >
      <Preferences/>
    </Modal>
  </>;
}
